(() => {
  window.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      const oneTimePurchaseInput = document.querySelector(
        "[data-option-onetime] input"
      );
      const subscriptionInput = document.querySelector(
        "[data-option-subsave] input"
      );

      oneTimePurchaseInput?.addEventListener("change", () => {
        window.Abra.useSellingPlanPriceOnProductBlock = false;
      });

      subscriptionInput?.addEventListener("change", () => {
        window.Abra.useSellingPlanPriceOnProductBlock = true;
      });
    }, 2500);
  });
})();
